import { CourseStatusAttemptEnum } from '@/client/courses';
import { LearnerContentList } from '@/pages/dashboards/learner/courses/LearnerContentList';
import { LearnerDashboardTabs } from '@/pages/dashboards/learner/courses/LearnerDashboardTabs';
import React from 'react';
import { LearnerLayout } from '../LearnerLayout';

type LearnerDashboardPageProps = {
  type: CourseStatusAttemptEnum.IN_PROGRESS | CourseStatusAttemptEnum.COMPLETED;
  atLeastOneCompleted?: boolean;
  isLoading?: boolean;
};

export const LearnerDashboardPage: React.FC<LearnerDashboardPageProps> = ({
  type,
  atLeastOneCompleted,
  isLoading,
}) => {
  return (
    <LearnerLayout isLoading={isLoading ?? false}>
      <LearnerDashboardTabs />
      <LearnerContentList
        type={type}
        atLeastOneCompleted={!!atLeastOneCompleted}
      />
    </LearnerLayout>
  );
};
